export const getBackgroundColorClassName = (classes, bg?: string) => ({
    [classes.bgWhite]: bg === 'white',
    [classes.bgWhiteAndOrange]: bg === 'whiteAndOrange',
    [classes.bgOrange]: bg === 'orange',
    [classes.bgLightOrange]: bg === 'light-orange',
    [classes.bgGrey]: bg === 'grey',
    [classes.bgGreen]: bg === 'green',
    [classes.bgBlack]: bg === 'black',
    [classes.alternateBgColor]: bg === 'alternateColor',
    [classes.bgRed]: bg === 'red',
    [classes.bgBlack1000]: bg === 'black-1000',
});
